@if (avatarType === WalletAvatarType.WEB_3_AVATAR) {
    <div class="wallet-avatar -web3"
         [style]="address | walletAvatar:avatarType"
         (click)="onClickToggleAvatarType($event)">
    </div>
} @else {
    <img class="wallet-avatar"
         [src]="address | walletAvatar:avatarType"
         (click)="onClickToggleAvatarType($event)" />
}
